import { formatDateOnly } from './dateHelpers';

/**
 * Interface cho dữ liệu filter từ form
 */
export interface FilterData {
    saleOrgCode?: string;
    wasteHandoverPlanCode?: string;
    productCode?: string;
    productName?: string;
    vendorNumber?: string;
    vendorName?: string;
    storageLocation?: string;
    handoverDocumentNumber?: string;
    deliveryDateFrom?: any;
    deliveryDateTo?: any;
    createTimeFrom?: any;
    createTimeTo?: any;
    wasteGroupingEnvironmentPermitId?: string;
    wasteGroupingContractId?: string;
    wasteGroupingContractIds?: string[];
    actived?: boolean;
}

/**
 * Xây dựng payload cho export (export list và export edit template)
 * @param filters Dữ liệu filter từ form
 * @returns Payload đã định dạng để gửi lên API
 */
export const buildExportPayload = (filters: FilterData) => {
    // Xử lý wasteGroupingContractIds: nếu có 1 item thì set WasteGroupingContractId, nếu nhiều thì set WasteGroupingContractIds
    let wasteGroupingContractId: string | undefined;
    let wasteGroupingContractIds: string[] | undefined;
    
    if (filters.wasteGroupingContractIds && filters.wasteGroupingContractIds.length > 0) {
        if (filters.wasteGroupingContractIds.length === 1) {
            wasteGroupingContractId = filters.wasteGroupingContractIds[0];
        } else {
            wasteGroupingContractIds = filters.wasteGroupingContractIds;
        }
    } else if (filters.wasteGroupingContractId) {
        wasteGroupingContractId = filters.wasteGroupingContractId;
    }

    return {
        saleOrgCode: filters.saleOrgCode,
        wasteHandoverPlanCode: filters.wasteHandoverPlanCode,
        productCode: filters.productCode,
        productName: filters.productName,
        vendorNumber: filters.vendorNumber,
        vendorName: filters.vendorName,
        storageLocation: filters.storageLocation,
        handoverDocumentNumber: filters.handoverDocumentNumber,
        deliveryDateFrom: formatDateOnly(filters.deliveryDateFrom),
        deliveryDateTo: formatDateOnly(filters.deliveryDateTo),
        createTimeFrom: formatDateOnly(filters.createTimeFrom),
        createTimeTo: formatDateOnly(filters.createTimeTo),
        wasteGroupingEnvironmentPermitId: filters.wasteGroupingEnvironmentPermitId,
        wasteGroupingContractId: wasteGroupingContractId,
        wasteGroupingContractIds: wasteGroupingContractIds,
        actived: filters.actived,
    };
};

/**
 * Xây dựng payload cho gửi email (tương tự export nhưng có thêm plantCode)
 * @param filters Dữ liệu filter từ form
 * @returns Payload đã định dạng để gửi lên API
 */
export const buildSendEmailPayload = (filters: FilterData) => {
    return {
        ...buildExportPayload(filters),
        plantCode: filters.saleOrgCode, // plantCode có thể lấy từ saleOrgCode
    };
};

